import React, { useMemo } from "react";
import { Alert, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useUserData } from "../../context/UserDataFetcher";

const BannerContainer = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "calc(var(--ion-safe-area-top, 0px) + 8px)",
  zIndex: theme.zIndex.snackbar + 20,
  padding: theme.spacing(0.5, 1),
  backgroundColor: "transparent",
  pointerEvents: "none",
  "& > *": {
    pointerEvents: "auto",
  },
}));

const RoleStatusBanner: React.FC = () => {
  const userData = useUserData();

  const show = useMemo(() => {
    // userData loaded but missing role
    return Boolean(userData) && !Boolean((userData as any)?.role);
  }, [userData]);

  if (!show) return null;

  return (
    <BannerContainer>
      <Alert
        severity="warning"
        icon={<WarningAmberIcon fontSize="small" />}
        sx={{ alignItems: "center" }}
        variant="filled"
      >
        <Typography variant="body2">Missing role. Contact your administrator.</Typography>
      </Alert>
    </BannerContainer>
  );
};

export default RoleStatusBanner;

